export interface IAddress {
  id?: number;
  streetName?: string | null;
  houseNumber?: number | null;
  houseNumberExtension?: string | null;
  postalCode?: string | null;
  city?: string | null;
  country?: string | null;
}

export const defaultValue: Readonly<IAddress> = {};
